import { render, staticRenderFns } from "./No_name.vue?vue&type=template&id=88b3bf7a&scoped=true&"
import script from "./No_name.vue?vue&type=script&lang=js&"
export * from "./No_name.vue?vue&type=script&lang=js&"
import style0 from "./No_name.vue?vue&type=style&index=0&id=88b3bf7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b3bf7a",
  null
  
)

export default component.exports